import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import _ from 'lodash';
import { connect } from 'react-redux';
import { numberWithCommas } from 'helper';
import { ModalContext } from 'App';
import FixTaxUpdateModal from './FixTaxUpdateModal';
import FixTaxAddModal from './FixTaxAddModal';
import * as actions from '../action';
import * as c from '../constant';

function FixTax({
  businessId, handleComputeFixedTax, deleteFixTax,
  getBusinessFixTaxList, businessFixTaxList,
  fixTaxList, transactionStatus,
}) {
  const setModal = useContext(ModalContext);

  const handleUpdateFixTaxData = () => {
    getBusinessFixTaxList(businessId);
    handleComputeFixedTax();
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <FixTaxAddModal
        businessId={businessId}
        fixTaxList={fixTaxList}
        handleUpdateFixTaxData={handleUpdateFixTaxData}
      />,
      title: 'Add Fix Tax',
      modalSize: 'modal-md',
    });
  };

  const handleUpdateModal = id => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <FixTaxUpdateModal
        id={id}
        handleUpdateFixTaxData={handleUpdateFixTaxData}
        businessId={businessId}
        fixTaxList={fixTaxList}
      />,
      title: 'Update Fix Tax',
      modalSize: 'modal-md',
    });
  };

  const handleDeleteFixTax = data => (e) => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure you want to delete ${_.get(data, 'attributes._fix_tax_name') || 'this item'}?`,
      () => {
        deleteFixTax(businessId, data.id, () => {
          handleUpdateFixTaxData();
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
    );
  };

  return (
    <React.Fragment>
      <div className="row mb-3 d-flex align-items-center">
        <div className="col py-0">
          <h3 className="m-0">Fix Tax</h3>
        </div>
        <div className="col py-0 m-0 d-flex">
          {transactionStatus === 'FOR APPEARANCE' ? (
            <button
              type="button"
              className="btn btn-secondary btn-round font-weight-bold px-4 ml-auto mr-1"
              onClick={handleAddModal}
            >
              Add Fix Tax <i className="fas fa-plus ml-2" />
            </button>
          ) : ''}
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-12 pb-3">
          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <td>Name</td>
                  <td>Quantity</td>
                  {transactionStatus === 'FOR APPEARANCE'
                    ? (
                      <React.Fragment>
                        <td>Fix Tax Amount</td>
                        <td />
                      </React.Fragment>
                    )
                    : <td>Fix Tax Amount</td>}
                </tr>
              </thead>
              <tbody>
                {_.isEmpty(businessFixTaxList) ? (
                  <tr className="w-100">
                    <td colSpan={`${transactionStatus === 'FOR APPEARANCE' ? 4 : 3}`} className="text-center border-top p-4 text-muted">
                      This Section is Empty
                    </td>
                  </tr>
                ) : (
                  businessFixTaxList.map(item => (
                    <tr key={item.id}>
                      <td className="border-top">{_.get(item, 'attributes._fix_tax_name')}</td>
                      <td className="border-top">{_.get(item, 'attributes.quantity')}</td>
                      {transactionStatus === 'FOR APPEARANCE' ? (
                        <React.Fragment>
                          <td className="border-top">{numberWithCommas(_.get(item, 'attributes._fix_tax_amount'))}</td>
                          <td className="border-top d-flex">
                            <button
                              type="button"
                              className="btn-blank ml-auto"
                              onClick={handleUpdateModal(item.id)}
                            >
                              <i className="far fa-edit icon-edit" />
                            </button>
                            <button
                              type="button"
                              className="btn-blank"
                              onClick={handleDeleteFixTax(item)}
                            >
                              <i className="far fa-trash-alt icon-delete" />
                            </button>
                          </td>
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <td className="border-top">{numberWithCommas(_.get(item, 'attributes._fix_tax_amount'))}</td>
                        </React.Fragment>
                      )}
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

FixTax.propTypes = {
  businessId: PropTypes.string.isRequired,
  handleComputeFixedTax: PropTypes.instanceOf(Function).isRequired,
  getBusinessFixTaxList: PropTypes.instanceOf(Function).isRequired,
  deleteFixTax: PropTypes.instanceOf(Function).isRequired,
  businessFixTaxList: PropTypes.instanceOf(Array).isRequired,

  fixTaxList: PropTypes.instanceOf(Array).isRequired,
  transactionStatus: PropTypes.string,
};

FixTax.defaultProps = {
  transactionStatus: '',
};

const mapStateToProps = ({ api }) => ({
  businessFixTaxList: _.get(api, `${c.GET_BUSINESS_FIX_TAX_LIST}.list`) || [],
  fixTaxList: _.get(api, `${c.GET_FIX_TAX_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withRouter,
  connect(
    mapStateToProps,
    actions,
  ),
]);


export default enhance(FixTax);
